




















import Vue from 'vue'

export default Vue.extend({
  inheritAttrs: false,
  props: {
    title: {
      type: String,
      default: '',
    },
    tag: {
      type: String,
      default: '',
    },
    pxHeight: {
      type: Number,
      default: 300,
    },
    captions: {
      type: Array,
      default: () => [],
    },
  },
  data() {
    return {
      offset: 20 as number,
    }
  },
  computed: {
    wrapperStyle() {
      return {
        width: '100%',
        height: `${this.pxHeight - this.offset}px`,
      }
    },
    slotStyle() {
      return {
        width: ' 100%',
        height: `${this.pxHeight}px`,
        position: 'relative',
        // top: `${-this.offset}px`
      }
    },
  },
})
